module.exports = __webpack_public_path__ + "static/media/direccion.2e8b6e97.png";